import './styles.scss'
import { ReactNode, useState } from 'react'

import * as Dialog from '@radix-ui/react-dialog'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'

const CLASS_NAME = 'gby-k2g-animation-modal'

export type AnimationPayoutModalProps = {
  children: ReactNode
  title: string
  description: string
  footer: JSX.Element
  overlayZIndex?: number
  canClose: boolean
  onClose: () => void
}

export const DismissibleAnimationModal = ({
  canClose,
  children,
  description,
  footer,
  title,
  overlayZIndex,
  onClose,
}: AnimationPayoutModalProps) => {
  const [open, setOpen] = useState<boolean>(true)

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(open) => {
        if (!open && canClose) {
          setOpen(open)
          onClose()
        }
      }}>
      <Dialog.Overlay className={`${CLASS_NAME}__overlay`} style={{ zIndex: overlayZIndex ?? 5 }} />

      <Dialog.Content className={`${CLASS_NAME}`}>
        <VisuallyHidden.Root>
          <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
          <Dialog.Description>{description}</Dialog.Description>
        </VisuallyHidden.Root>
        <div className={`${CLASS_NAME}__top-area`}>{children}</div>
        <div className={`${CLASS_NAME}__bottom-area`}>{footer}</div>
      </Dialog.Content>
    </Dialog.Root>
  )
}
